const AdminMenu =  [
    ["/dashboard", 'ADMIN-TOP-MENU.DASHBOARD'],
    ["/tax_payers", 'USER-TOP-MENU.TAX-PAYERS'],
    ["/tax_payer_match_requests", 'USER-TOP-MENU.TAX-PAYER-MATCH-REQUESTS'],
    ["/payment_report", 'USER-TOP-MENU.PAYMENT_REPORTS'],
    ["/forecast", 'ADMIN-TOP-MENU.FORECAST'],
    ["/performance", 'ADMIN-TOP-MENU.PERFORMANCE'],
    ["/approval", 'ADMIN-TOP-MENU.APPROVAL'],
    ["/notification", 'ADMIN-TOP-MENU.NOTIFICATIONS'],
    //["/declarations", 'USER-TOP-MENU.DECLARATIONS'],
    ["/statistics", 'USER-TOP-MENU.STATISTICS'],
    // ["/formcreation_foradmin525", 'USER-TOP-MENU.FORM_CREATOR'],
    // ["/user_management", 'ADMIN-TOP-MENU.USER_MANAGEMENT'],
    ["/registrations_map", 'ADMIN-TOP-MENU.REGISTRATIONS_MAP'],
    ["/vehicle", 'ADMIN-TOP-MENU.VEHICLE'],
    ["/property-tax", 'ADMIN-TOP-MENU.PROPERTY_TAX'],
    ["/configuration", 'ADMIN-TOP-MENU.CONFIGURATION']
    // ["/admin", 'ADMIN-TOP-MENU.ADMIN']
];

const MayorTreasurerMenu = [
    ["/dashboard", 'ADMIN-TOP-MENU.DASHBOARD'],
    ["/tax_payers", 'USER-TOP-MENU.TAX-PAYERS'],
    ["/tax_payer_match_requests", 'USER-TOP-MENU.TAX-PAYER-MATCH-REQUESTS'],
    ["/payment_report", 'USER-TOP-MENU.PAYMENT_REPORTS'],
    ["/forecast", 'ADMIN-TOP-MENU.FORECAST'],
    ["/performance", 'ADMIN-TOP-MENU.PERFORMANCE'],
    ["/approval", 'ADMIN-TOP-MENU.APPROVAL'],
    ["/statistics", 'USER-TOP-MENU.STATISTICS'],
    ["/registrations_map", 'ADMIN-TOP-MENU.REGISTRATIONS_MAP'],
    ["/help", 'HELP_PAGE.TITLE']
];

const CentralReaderMenu = [
    ["/dashboard", 'ADMIN-TOP-MENU.DASHBOARD'],
    ["/tax_payers", 'USER-TOP-MENU.TAX-PAYERS'],
    ["/tax_payer_match_requests", 'USER-TOP-MENU.TAX-PAYER-MATCH-REQUESTS'],
    ["/payment_report", 'USER-TOP-MENU.PAYMENT_REPORTS'],
    ["/forecast", 'ADMIN-TOP-MENU.FORECAST'],
    ["/performance", 'ADMIN-TOP-MENU.PERFORMANCE'],
    ["/approval", 'ADMIN-TOP-MENU.APPROVAL'],
    ["/statistics", 'USER-TOP-MENU.STATISTICS'],
    ["/registrations_map", 'ADMIN-TOP-MENU.REGISTRATIONS_MAP'],
    ["/help", 'HELP_PAGE.TITLE']
];

const FinancialManagerAdministratorMenu = [
    ["/dashboard", 'ADMIN-TOP-MENU.DASHBOARD'],
    ["/tax_payers", 'USER-TOP-MENU.TAX-PAYERS'],
    ["/tax_payer_match_requests", 'USER-TOP-MENU.TAX-PAYER-MATCH-REQUESTS'],
    ["/payment_report", 'USER-TOP-MENU.PAYMENT_REPORTS'],
    ["/forecast", 'ADMIN-TOP-MENU.FORECAST'],
    ["/performance", 'ADMIN-TOP-MENU.PERFORMANCE'],
    ["/approval", 'ADMIN-TOP-MENU.APPROVAL'],
    ["/notification", 'ADMIN-TOP-MENU.NOTIFICATIONS'],
    ["/statistics", 'USER-TOP-MENU.STATISTICS'],
    ["/registrations_map", 'ADMIN-TOP-MENU.REGISTRATIONS_MAP'],
    ["/help", 'HELP_PAGE.TITLE']
];

const FinancialEditor = [
  ["/dashboard", 'ADMIN-TOP-MENU.DASHBOARD'],
  ["/tax_payers", 'USER-TOP-MENU.TAX-PAYERS'],
  ["/tax_payer_match_requests", 'USER-TOP-MENU.TAX-PAYER-MATCH-REQUESTS'],
  ["/payment_report", 'USER-TOP-MENU.PAYMENT_REPORTS'],
  ["/forecast", 'ADMIN-TOP-MENU.FORECAST'],
  ["/performance", 'ADMIN-TOP-MENU.PERFORMANCE'],
  ["/statistics", 'USER-TOP-MENU.STATISTICS'],
  ["/registrations_map", 'ADMIN-TOP-MENU.REGISTRATIONS_MAP'],
  ["/approval", 'ADMIN-TOP-MENU.APPROVAL'],
  ["/help", 'HELP_PAGE.TITLE']
];

const CentralEditorMenu = [
    ["/dashboard", 'ADMIN-TOP-MENU.DASHBOARD'],
    ["/tax_payers", 'USER-TOP-MENU.TAX-PAYERS'],
    ["/tax_payer_match_requests", 'USER-TOP-MENU.TAX-PAYER-MATCH-REQUESTS'],
    ["/payment_report", 'USER-TOP-MENU.PAYMENT_REPORTS'],
    ["/forecast", 'ADMIN-TOP-MENU.FORECAST'],
    ["/performance", 'ADMIN-TOP-MENU.PERFORMANCE'],
    ["/approval", 'ADMIN-TOP-MENU.APPROVAL'],
    ["/notification", 'ADMIN-TOP-MENU.NOTIFICATIONS'],
    ["/statistics", 'USER-TOP-MENU.STATISTICS'],
    ["/registrations_map", 'ADMIN-TOP-MENU.REGISTRATIONS_MAP'],
    ["/help", 'HELP_PAGE.TITLE']
];

const SecretaryAssistantMenu = [
    ["/dashboard", 'ADMIN-TOP-MENU.DASHBOARD', false],
    ["/tax_payers", 'USER-TOP-MENU.TAX-PAYERS', true],
    ["/payment_report", 'USER-TOP-MENU.PAYMENT_REPORTS', false],
    ["/forecast", 'ADMIN-TOP-MENU.FORECAST', false],
    ["/performance", 'ADMIN-TOP-MENU.PERFORMANCE', false],
    ["/registrations_map", 'ADMIN-TOP-MENU.REGISTRATIONS_MAP', false],
    ["/help", 'HELP_PAGE.TITLE', false]
];

const AgentRecenseurMenu = [
  ["/property-tax", 'ADMIN-TOP-MENU.PROPERTY_TAX', true],
];

const PropertiesEditorMenu = [
  ["/property-tax", 'ADMIN-TOP-MENU.PROPERTY_TAX', true],
];

const PropertiesLecteurMenu = [
  ["/property-tax", 'ADMIN-TOP-MENU.PROPERTY_TAX', true],
];

const FinancialManagerAdministratorPropertiesEditorMenu = [
  ["/dashboard", 'ADMIN-TOP-MENU.DASHBOARD'],
  ["/tax_payers", 'USER-TOP-MENU.TAX-PAYERS'],
  ["/tax_payer_match_requests", 'USER-TOP-MENU.TAX-PAYER-MATCH-REQUESTS'],
  ["/payment_report", 'USER-TOP-MENU.PAYMENT_REPORTS'],
  ["/forecast", 'ADMIN-TOP-MENU.FORECAST'],
  ["/performance", 'ADMIN-TOP-MENU.PERFORMANCE'],
  ["/statistics", 'USER-TOP-MENU.STATISTICS'],
  ["/registrations_map", 'ADMIN-TOP-MENU.REGISTRATIONS_MAP'],
  ["/help", 'HELP_PAGE.TITLE'],
  ["/property-tax", 'ADMIN-TOP-MENU.PROPERTY_TAX', true],
];

const FinancialManagerAdministratorPropertiesLecteurMenu = [
  ["/dashboard", 'ADMIN-TOP-MENU.DASHBOARD'],
  ["/tax_payers", 'USER-TOP-MENU.TAX-PAYERS'],
  ["/tax_payer_match_requests", 'USER-TOP-MENU.TAX-PAYER-MATCH-REQUESTS'],
  ["/payment_report", 'USER-TOP-MENU.PAYMENT_REPORTS'],
  ["/forecast", 'ADMIN-TOP-MENU.FORECAST'],
  ["/performance", 'ADMIN-TOP-MENU.PERFORMANCE'],
  ["/statistics", 'USER-TOP-MENU.STATISTICS'],
  ["/registrations_map", 'ADMIN-TOP-MENU.REGISTRATIONS_MAP'],
  ["/help", 'HELP_PAGE.TITLE'],
  ["/property-tax", 'ADMIN-TOP-MENU.PROPERTY_TAX', true],
];

const MayorTreasurerPropertiesLecteurMenu = [
  ["/dashboard", 'ADMIN-TOP-MENU.DASHBOARD'],
  ["/tax_payers", 'USER-TOP-MENU.TAX-PAYERS'],
  ["/tax_payer_match_requests", 'USER-TOP-MENU.TAX-PAYER-MATCH-REQUESTS'],
  ["/payment_report", 'USER-TOP-MENU.PAYMENT_REPORTS'],
  ["/forecast", 'ADMIN-TOP-MENU.FORECAST'],
  ["/performance", 'ADMIN-TOP-MENU.PERFORMANCE'],
  ["/approval", 'ADMIN-TOP-MENU.APPROVAL'],
  ["/statistics", 'USER-TOP-MENU.STATISTICS'],
  ["/registrations_map", 'ADMIN-TOP-MENU.REGISTRATIONS_MAP'],
  ["/help", 'HELP_PAGE.TITLE'],
  ["/property-tax", 'ADMIN-TOP-MENU.PROPERTY_TAX', true],
]

const MenuCategories = new Map<string, (string|boolean)[][]>([
    ["ADMIN", AdminMenu],
    ["MAYOR_TREASURER", MayorTreasurerMenu],
    ["CENTRAL_READER", CentralReaderMenu],
    ["FINANCIAL_MANAGER_ADMINISTRATOR", FinancialManagerAdministratorMenu],
    ["FINANCIAL_EDITOR", FinancialEditor],
    ["CENTRAL_EDITOR", CentralEditorMenu],
    ["SECRETARY_ASSISTANT", SecretaryAssistantMenu],
    ["AGENT_RECENSEUR", AgentRecenseurMenu],
    ["PROPERTIES_EDITOR", PropertiesEditorMenu],
    ["PROPERTIES_LECTEUR", PropertiesLecteurMenu],
    ["FINANCIAL_MANAGER_ADMINISTRATOR_AND_PROPERTIES_EDITOR", FinancialManagerAdministratorPropertiesEditorMenu],
    ["FINANCIAL_MANAGER_ADMINISTRATOR_AND_PROPERTIES_LECTEUR", FinancialManagerAdministratorPropertiesLecteurMenu],
    ["MAYOR_TREASURER_AND_PROPERTIES_LECTEUR", MayorTreasurerPropertiesLecteurMenu],
]);

const ChildRoutes = [
    {
      parent:'/property-tax', children: ['/boundary-configuration','/lot-editor','/building-editor',
        '/property-tax-form-configuration','/property-tax-list', '/lot-list', '/pt-form-editor/lotAttrForm','/pt-form-editor/propTaxForm']
    },
    {
      parent:'/tax_payers', children: ['/tx_declarations']
    },
    {
      parent:'/configuration', children: ['/payment_configuration','/form_editor_configuration',
        '/user_management','/admin','/template_manager','/template_editor/avis','/sms_configuration',
      ]
    }
  ];

export { MenuCategories, ChildRoutes };
